import { render, staticRenderFns } from "./5b76cb7f-1227-420e-bdf3-078f79314708.vue?vue&type=template&id=b771d450&scoped=true"
import script from "./5b76cb7f-1227-420e-bdf3-078f79314708.vue?vue&type=script&lang=ts"
export * from "./5b76cb7f-1227-420e-bdf3-078f79314708.vue?vue&type=script&lang=ts"
import style0 from "./5b76cb7f-1227-420e-bdf3-078f79314708.vue?vue&type=style&index=0&id=b771d450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b771d450",
  null
  
)

export default component.exports